/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins, router } from "@/plugins";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";

const app = createApp(App);

registerPlugins(app);

router.isReady().then(() => {
  app.mount("#app");
});

// Pageviews: het Umami v2-script volgt SPA-routewissels zelf (auto-track via de
// History API), dus hier geen handmatige trackView/track - dat zou dubbel tellen.
